import { inject, observer } from 'mobx-react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import branch from 'recompose/branch'
import React from 'react'
import PositionWrapper, { style } from '../../components/2d/position/PositionWrapper'
import injectSheet from 'react-jss'
import { INTERACTIVE_ELEMENT_OPTIONS } from '../../constants'
import { get2DContextCoordinates } from '../../methods/normalizeData'

const injectStore = stores => ({
    tick: stores.streams.position.tick,
    projectToCam: stores.streams.position.projectToCam,
})

const with3DContextPosition = Component => ({ center: initialCenter, projectToCam, ...props }) => {
    let center = projectToCam(initialCenter)
    center.x = ((center.x + 1) / 2) * window.innerWidth
    center.y = (-(center.y - 1) / 2) * window.innerHeight
    return (
        <Component
            {...{
                ...props,
                ...center,
                initialCenter,
            }}
        />
    )
}

const with2DContextPosition = Component => ({
    viewportWidth,
    photoWidth,
    viewportHeight,
    photoHeight,
    center: initialCenter,
    coordinates,
    photoPlayer,
    ...props
}) => {
    const { left, top, width: boundingRectWidth, height: boundingRectHeight } = photoPlayer

    let leftOffset = left,
        topOffset = top,
        heightRatio = 1,
        width = viewportWidth > photoWidth ? photoWidth : viewportWidth,
        height = viewportHeight > photoHeight ? photoHeight : viewportHeight

    // For portrait images we need to offset the width to adjust for the difference between the bounding rect height
    // and image natural height
    if (width < height) {
        heightRatio = height / boundingRectHeight

        const currImageWidth = width / heightRatio

        const widthOffset = (boundingRectWidth - currImageWidth) / 2

        leftOffset += widthOffset
    }

    const { x, y, z } = get2DContextCoordinates(coordinates)(width, height)
    const center = { x: x / heightRatio + leftOffset, y: y / heightRatio + topOffset, z: z }

    return (
        <Component
            {...{
                ...props,
                ...center,
                initialCenter,
                zIndex: 3,
            }}
        />
    )
}

const mapStateToProps = state => ({
    viewportWidth: state.getIn(['device', 'viewportWidth']),
    viewportHeight: state.getIn(['device', 'viewportHeight']),
    photoWidth: state.getIn(['tour', 'mainMedia', 'width']),
    photoHeight: state.getIn(['tour', 'mainMedia', 'height']),
    photoPlayer: state.getIn(['tour', 'mainMedia', 'photoPlayer']),
})

export default compose(
    inject(injectStore),
    observer,
    branch(
        ({ contextType }) => contextType == INTERACTIVE_ELEMENT_OPTIONS.CONTEXT.context2D,
        compose(
            connect(mapStateToProps),
            with2DContextPosition
        ),
        with3DContextPosition
    ),
    injectSheet(style),
    PositionWrapper
)
